import { render, staticRenderFns } from "./ErrorList.vue?vue&type=template&id=b06e7614&scoped=true"
import script from "./ErrorList.vue?vue&type=script&lang=js"
export * from "./ErrorList.vue?vue&type=script&lang=js"
import style0 from "./ErrorList.vue?vue&type=style&index=0&id=b06e7614&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06e7614",
  null
  
)

export default component.exports